import React, { Fragment, useEffect, useState } from 'react';
import classNames from 'classnames';
import { tabbable } from 'tabbable';
import { Avatar, Badge, Button, Layout, Menu, Popover, Drawer } from '@nackle/origami';
import { LocaleString, getString } from '@nackle/intl-tools';
import NotificationsPopover from '../notifications-popover/notifications-popover.jsx';
import RewardsPopover from '../rewards-popover/rewards-popover.jsx';
import CookieNotice from '../cookie-notice/cookie-notice.jsx';
import FetchLogo from '../fetch-logo.js';
import { Menu as MenuIcon } from '@nackle/origami-icons';
import icons, { Store, Games, Bell, LogOut, LinkExternal, Close, Gift } from '@nackle/origami-icons';
import umbrellaPaths from '../umbrella-paths.js';
import { routeHistory } from '@nackle/biw-web-router';
import { SendEvent } from '../event-proxy.js';
import { KAFKA_TOPICS } from '../constants.js';
import './deck.less';


export default class Deck extends React.Component {
    state = {
        contentLoaded: false,
        piersUser: {},
        hasFetchedFromNavigation: false,
        deckRewardsVisible: false,
        deckRewardsDrawerVisible: false,
        deckArcadeVisible: false,
        deckMobileArcadeVisible: false,
        deckNotificationsVisible: false,
        deckMobileNotificationsVisible: false,
        deckUserVisible: false,
        deckMobileUserVisible: false,
        mobileMenuOpen: false,
        unreadNotificationCount: ''
    };

    componentDidMount() {
        const { hide } = this.props;
        this.deckEl = document.querySelector( '.nkl-deck-header' );

        if ( hide ) {
            document.querySelector( '.nkl-deck-app-root' ).classList.add( 'nkl-deck-no-header' );
        }
        const body = document.body;
        let lastScroll = 0;
        window.addEventListener( 'scroll', () => {
            const currentScroll = window.pageYOffset;
            if ( currentScroll <= 0 ) {
              body.classList.remove( 'scroll-up' );
              return;
            }
            if ( currentScroll > lastScroll && !body.classList.contains( 'scroll-down' ) ) {
              // down
              body.classList.remove( 'scroll-up' );
              body.classList.add( 'scroll-down' );
            } else if (
              currentScroll < lastScroll &&
              body.classList.contains( 'scroll-down' )
            ) {
              // up
              body.classList.remove( 'scroll-down' );
              body.classList.add( 'scroll-up' );

            }
            lastScroll = currentScroll;
          } );
        document.addEventListener( 'mouseup', this.handleClickOffPopover );
        document.addEventListener( 'keydown', this.handleEscKey );
    }

    componentWillUnmount() {
        document.removeEventListener( 'mousedown', this.handleClickOffPopover );
        document.removeEventListener( 'keydown', this.handleEscKey );
    }
    deriveUrl = url => {
        const env = window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
            return [ 'localhost', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
        } );
        return url.toLowerCase().replace( '(env.)', env ? env + '.' : '' );
    };
    normalizeUrl = url => {
        const { auth } = this.props;
        const isHomePrimary = url.indexOf( 'home' ) > 0;
        const isDMSA = window.location.hostname.indexOf( 'myawardsite' ) > 0;
        if ( isHomePrimary && isDMSA ) {
            const completeUrl = `${ this.deriveUrl( 'https://(env.)api.biw.cloud/v1/id' ) }/host-transfer`;
            const companyId = auth?.state?.claims?.company_id;
            const normalUrl = ( url && url?.substring( 0, 4 ) !== 'http' ) ? `https://${ url }` : url;
            return `${ completeUrl }?companyId=${ companyId }&redirectUri=${ normalUrl }`;

        }
        return ( url && url?.substring( 0, 4 ) !== 'http' ) ? `https://${ url }` : url;
    };

    getUrl = identifier => {
        const company = this.props.currentCompany || {};
        const list = company.identifierList || [];
        return list.find( str => str.includes( identifier ) );
    };

    getMarketplaceUrl = () => {
        if ( this.props.isUmbrella ) {
            return `${ window.location.origin }/marketplace`;
        } else {
            return this.getUrl( '.marketplace.' );
        }
    };

    endDelegate = () => {
        const { auth } = this.props;
        auth.restoreIdentity();
    };

    closePopovers = cb => {
        this.setState( {
            deckRewardsVisible: false,
            deckArcadeVisible: false,
            deckNotificationsVisible: false,
            deckUserVisible: false
        } );
    };
    dismissRewardsDrawer = () => {
        this.setState( {
            deckRewardsDrawerVisible: false
        } );
        //overflow was set to hidden when drawer was opened so allow scroll again
        document.body.style.overflow = null;
    };
    dismissArcadeDrawer = () => {
        this.setState( {
            deckMobileArcadeVisible: false
        } );
        //overflow was set to hidden when drawer was opened so allow scroll again
        document.body.style.overflow = null;
    };
    dismissNotificationsDrawer = () => {
        this.setState( {
            deckMobileNotificationsVisible: false
        } );
        //overflow was set to hidden when drawer was opened so allow scroll again
        document.body.style.overflow = null;
    };
    dismissUserDrawer = () => {
        this.setState( {
            deckMobileUserVisible: false
        } );
        //overflow was set to hidden when drawer was opened so allow scroll again
        document.body.style.overflow = null;
    };
    handlePopovers = type => e => {
        const visible = this.state[ `${ type }Visible` ];
        const visibleEl = document.querySelector( '.nkl-deck-popover:not(.ant-popover-hidden)' );
        if ( !visibleEl ) {
            this.setState( { [ `${ type }Visible` ]: !visible } );
        }
    };

    handleClickOffPopover = e => {
        const visibleEl = document.querySelector( '.nkl-deck-popover:not(.ant-popover-hidden)' );
        // if click occurs outside any visible popover, set all popovers to close
        if ( !visibleEl?.contains( e.target ) ) {
            this.closePopovers();
        }
    };

    handleEscKey = e => {
        if ( e.key === 'Escape' ) {
            this.closePopovers();
        }
    };

    handleNotificationChange = ( count ) => {
        this.setState( { unreadNotificationCount: count } );
    };
    toggleRewardsDrawer = () => {
        const { deckRewardsDrawerVisible } = this.state;
        this.setState( {
            deckRewardsDrawerVisible: !deckRewardsDrawerVisible,
            //dismiss the other drawers if they're open
            deckMobileArcadeVisible: false,
            deckMobileNotificationsVisible: false,
            deckMobileUserVisible: false
        } );
        if ( !deckRewardsDrawerVisible ) {
            //when drawer is open, lock body so can't scroll
            document.body.style.overflow = 'hidden';
        } else {
            //allow scroll again when drawer is closed
            document.body.style.overflow = null;
        }
    };
    toggleArcadeDrawer = () => {
        const { deckMobileArcadeVisible } = this.state;
        this.setState( {
            deckMobileArcadeVisible: !deckMobileArcadeVisible,
            //dismiss the other drawers if they're open
            deckRewardsDrawerVisible: false,
            deckMobileNotificationsVisible: false,
            deckMobileUserVisible: false
        } );
        if ( !deckMobileArcadeVisible ) {
            //when drawer is open, lock body so can't scroll
            document.body.style.overflow = 'hidden';
        } else {
            //allow scroll again when drawer is closed
            document.body.style.overflow = null;
        }
    };
    toggleNotificationsDrawer = () => {
        const { deckMobileNotificationsVisible } = this.state;
        this.setState( {
            deckMobileNotificationsVisible: !deckMobileNotificationsVisible,
            //dismiss the other drawers if they're open
            deckMobileArcadeVisible: false,
            deckRewardsDrawerVisible: false,
            deckMobileUserVisible: false
        } );
        if ( !deckMobileNotificationsVisible ) {
            //when drawer is open, lock body so can't scroll
            document.body.style.overflow = 'hidden';
        } else {
            //allow scroll again when drawer is closed
            document.body.style.overflow = null;
        }
    };
    toggleUserDrawer = () => {
        const { deckMobileUserVisible } = this.state;
        this.setState( {
            deckMobileUserVisible: !deckMobileUserVisible,
            //dismiss the other drawers if they're open
            deckMobileArcadeVisible: false,
            deckRewardsDrawerVisible: false,
            deckMobileNotificationsVisible: false
        } );
        if ( !deckMobileUserVisible ) {
            //when drawer is open, lock body so can't scroll
            document.body.style.overflow = 'hidden';
        } else {
            //allow scroll again when drawer is closed
            document.body.style.overflow = null;
        }
    };
    toggleSidebar = () => {
        const { toggleSidebar, sidebarOpen } = this.props;
        if ( typeof toggleSidebar === 'function' ) {
            toggleSidebar();
            this.dismissRewardsDrawer();
            this.dismissArcadeDrawer();
            this.dismissNotificationsDrawer();
            this.dismissUserDrawer();
            if ( sidebarOpen === false ) {
                //when drawer is open, lock body so can't scroll
                document.body.style.overflow = 'hidden';
            } else if ( sidebarOpen === true ) {
                //allow scroll again when drawer is closed
                document.body.style.overflow = null;
            }
        }
    };
    static getDerivedStateFromProps( props, state ) {
        if ( state.unreadNotificationCount === '' && props.notifications && props.notifications.length > 0 ) {
            state.unreadNotificationCount = props.notifications.reduce( ( accumulator, item ) => {
                return item.status === 'UNREAD'
                    ? accumulator + 1
                    : accumulator;
            }, 0 );
        }
        return state;
    }

    render() {
        const {
            auth,
            className,
            hide,
            contentLoaded,
            loaded,
            isUmbrella,
            notifications,
            isDM,
            user,
            leftNav,
            userNavData,
        } = this.props;
        const { deckRewardsDrawerVisible, deckMobileArcadeVisible, deckMobileNotificationsVisible, deckMobileUserVisible } = this.state;
        const propsTokens = this.props.tokens;
        let isDelegate;
        let name;
        if ( auth.state.actor && auth.state.actor.person_id ) {
            isDelegate = true;
            name = `${ auth.state.claims.given_name } ${ auth.state.claims.family_name }`;
        } else {
            isDelegate = false;
            name = '';
        }

        // Can't use destructuring and defaults since GraphQl can return nulls,
        // and null overwrites a default.
        const piersUser = this.props.piersUser || {};
        const profile = piersUser.profile || {};
        const solutions = piersUser.solutions || [];
        const experiences = solutions[ 0 ]?.experiences;
        const primaryExperienceId = solutions[ 0 ]?.primaryExperience;
        const primaryExperienceUrl = experiences?.find( ex => ex.id === primaryExperienceId )?.url;
        const hasProfile = experiences?.find( ex => ex.identity === 'profile' )?.url;
        const marketplaceItems = piersUser.marketplace?.menuItems;
        const cashier = piersUser.cashier || {};
        const avatar = profile.avatar || undefined;
        const locale = profile.locale || 'en-US';
        const points = cashier.points;
        const tokens = cashier.tokens || [];
        const giftCodes = cashier.giftCodes || [];
        const firstName = profile.givenName;
        let tokenCount = tokens.length;

        const marketplaceUrl = this.getMarketplaceUrl( 'marketplace' );
        const profileUrl = isUmbrella ? umbrellaPaths.profile : this.getUrl( 'profile' );
        const arcadeUrl = this.getUrl( '.arcade.' );
        const giftCodeUrl = this.getUrl( 'myawardcode' );

        const { deckRewardsVisible, deckArcadeVisible, deckNotificationsVisible, deckUserVisible, unreadNotificationCount } = this.state;
        const deckClasses = classNames(
            'nkl-deck-header',
            className,
            {
                'is-loaded': loaded,
                'is-hidden': hide,
                'not-sticky': true
            }
        );
        const stickyDeckClasses = classNames(
            'nkl-deck-user-info',
            'nkl-deck-header',
            'ant-layout-header',
            'sticky-header',
            { 'is-loaded': loaded }
        );
        const validGiftcodes = giftCodes.filter( gc => { return gc.status !== 'Redeemed';} );
        const hasMarketplace = marketplaceItems?.length && marketplaceUrl && !isDelegate;
        const hasGiftCode = validGiftcodes?.length > 0 && !isDelegate;

        // If a user spends a token, Deck will not know and can not update the token count.
        // Allow an app to pass tokens as a prop for Deck to have an up to date display
        // of the real current token count.
        if ( propsTokens ) {
            if ( typeof propsTokens === 'number' || typeof propsTokens === 'string' ) {
                tokenCount = propsTokens > 0 ? propsTokens : 0;
            } else if ( Array.isArray( propsTokens ) ) {
                tokenCount = propsTokens.length;
            }
        }

        return <Fragment><Layout.Header className={ deckClasses } id="deckHeader">
            {
                leftNav !== false &&
                <Button
                    className="menu-button nkl-btn"
                    aria-label="Menu button"
                    icon={ <MenuIcon fill={ '#59606D' } /> }
                    onClick={ this.toggleSidebar }
                >

            </Button>
            }
            { auth?.state?.claims?.company_id
                ? !isDM
                    ?
                    <a href={ primaryExperienceUrl ? this.normalizeUrl( primaryExperienceUrl ) : null }>
                        <img src={ FetchLogo( auth?.state?.claims?.company_id ) } alt="Home" className="deck-company-logo" />
                    </a>
                    :
                    <img src={ FetchLogo( auth?.state?.claims?.company_id ) } alt="Home" className="deck-company-logo" />
                : <div className="deck-logo-placeholder" />
            }
            { /* USER MENU */ }
            <span id="deck-userMenuContainer">
                <Popover
                    getPopupContainer={ () => document.getElementById( 'deck-userMenuContainer' ) }
                    overlayClassName="nkl-deck-popover nkl-deck-popover-menu-container"
                    placement="bottomRight"
                    onClick={ this.handlePopovers( 'deckUser' ) }
                    open={ deckUserVisible }
                    content={
                        <UserMenu
                            closePopovers={ this.closePopovers }
                            profileUrl={ profileUrl }
                            isDelegate={ isDelegate }
                            auth={ auth }
                            user={ user }
                            isUmbrella={ isUmbrella }
                            hasProfile={ hasProfile }
                            userNavData={ userNavData }
                            piersUser={ piersUser }
                        />
                    }>

                    <Button
                        onClick={ e => e.preventDefault() }
                        type="text" shape="circle"
                        className="nkl-deck-avatar-btn"
                        id="deckUserPopoverBtn"
                        aria-label={ getString( 'deck.label.userMenu' ) }
                        aria-haspopup="true"
                        aria-expanded={ deckUserVisible }>
                        <DeckAvatar
                            firstName={ firstName }
                            avatarUrl={ avatar }
                        />
                    </Button>
                </Popover>
            </span>
            { /* MOBILE USER MENU */ }
            <span id="deck-userMobileContainer">
                <Drawer
                    rootStyle={ { top: window.scrollY > 50 && !document.body.classList.contains( 'scroll-up' ) ? '50px' : '100px' } }
                    getContainer={ () => document.getElementById( 'deckSiteContent' ) }
                    className="nkl-deck-popover nkl-deck-popover-menu-container user-drawer"
                    onClose={ this.dismissUserDrawer }
                    width={ 320 }
                    title={
                        <div className="rewards-header-mobile">
                        <span className="gift-code-callout-header"><LocaleString code="deck.menu.salutation" replaceOptions={ { name: user?.claims?.given_name } } /></span>
                    </div>
                    }
                    closeIcon={ <Close /> }
                    placement="left"
                    open={ deckMobileUserVisible }
                >
                    <UserMenu
                        closePopovers={ this.dismissUserDrawer }
                        profileUrl={ profileUrl }
                        isDelegate={ isDelegate }
                        auth={ auth }
                        user={ this.props.user }
                        isUmbrella={ isUmbrella }
                        hasProfile={ hasProfile }
                        userNavData={ userNavData }
                    />
                </Drawer>
                <Button
                    type="text" shape="circle"
                    className="nkl-deck-avatar-btn"
                    id="deckUserPopoverBtn"
                    aria-label={ getString( 'deck.label.userMenu' ) }
                    aria-haspopup="true"
                    onClick={ this.toggleUserDrawer }
                    aria-expanded={ deckMobileUserVisible }>
                    <DeckAvatar
                        firstName={ firstName }
                        avatarUrl={ avatar }
                    />
                </Button>
            </span>
            { isDelegate && contentLoaded &&
                <span className="nkl-deck-delegate-text">
                    <LocaleString code="deck.delegate.info" replaceOptions={ { name: name } } />
                    { ' ' }
                    <Button
                        danger
                        size="small"
                        shape="round"
                        type="primary"
                        onClick={ this.endDelegate }>
                        { getString( 'deck.delegate.cancel' ) }
                    </Button>
                </span>
            }

            { /* Cookie Notice */ }
            <CookieNotice
                contentLoaded={ contentLoaded }
                user={ this.props.user }
                solutionId={ solutions[ 0 ]?.solutionId } />
        </Layout.Header>
        <div className={ stickyDeckClasses }>
                { /* SHOP/MERCHANDISE MENU (REWARDS POPOVER) */ }
                <div className="nkl-deck-button-container">
                    { ( hasMarketplace || hasGiftCode ) &&
                        <span id="deck-rewardsPopoverContainer">
                            <Popover
                                getPopupContainer={ () => document.getElementById( 'deck-rewardsPopoverContainer' ) }
                                placement="bottomRight"
                                overlayClassName="nkl-deck-popover rewards-deck-popover"
                                trigger="click"
                                open={ deckRewardsVisible }
                                onClick={ this.handlePopovers( 'deckRewards' ) }
                                width={ 396 }
                                content={
                                    <RewardsPopover
                                        closePopovers={ this.closePopovers }
                                        locale={ locale }
                                        points={ points }
                                        giftCodes={ giftCodes }
                                        marketplaceUrl={ marketplaceUrl }
                                        giftCodeUrl={ giftCodeUrl }
                                        menuItems={ marketplaceItems }
                                    />
                                }>
                                <Button
                                    type="text"
                                    shape="round"
                                    id="deckRewardsPopoverBtn"
                                    className="nkl-deck-rewards-btn"
                                    aria-label={ getString( 'deck.label.rewardsMenu' ) }
                                    aria-haspopup="true"
                                    icon={
                                       !hasMarketplace && hasGiftCode ?
                                            <span className="anticon nkl-deck-icon">
                                                <Gift className="nkl-deck-icon reward-icon" />
                                            </span>
                                            :
                                            <span className="anticon nkl-deck-icon">
                                                <Store className="nkl-deck-icon reward-icon" />
                                            </span>
                                    }
                                    aria-expanded={ deckRewardsVisible }>
                                    { points !== null && points >= 0 && hasMarketplace && <span className="points">{ points.toLocaleString( locale ) }</span> }
                                </Button>
                            </Popover>
                        </span>
                    }
                    { /* MOBILE SHOP/MERCH MENU */ }
                    { ( hasMarketplace || hasGiftCode ) &&
                        <span id="deck-rewardsMobileContainer">
                            <Drawer
                                rootStyle={ { top: window.scrollY > 50 && !document.body.classList.contains( 'scroll-up' ) ? '50px' : '100px' } }
                                getContainer={ () => document.getElementById( 'deckSiteContent' ) }
                                placement="left"
                                className="nkl-deck-popover rewards-deck-popover rewards-drawer"
                                trigger="click"
                                open={ deckRewardsDrawerVisible }
                                onClose={ this.dismissRewardsDrawer }
                                width={ 320 }
                                title={
                                    validGiftcodes && validGiftcodes.length > 0 ?
                                    <div className="rewards-header-mobile">
                                        <span className="anticon nkl-deck-icon"><Gift className="reward-gift-icon deck-primary-color" /></span>
                                        <span className="gift-code-callout-header"><LocaleString code="deck.rewardsPopover.RewardsTitle" /></span>
                                    </div>
                                    :
                                    <div className="rewards-header-mobile">
                                        <span className="anticon nkl-deck-icon"><Store className="reward-gift-icon deck-primary-color"/></span>
                                        <span className="gift-code-callout-header"><LocaleString code="deck.rewardsPopover.marketplace" /></span>
                                    </div>
                                }
                                closeIcon={ <Close /> }
                            >
                                <RewardsPopover
                                    closePopovers={ this.dismissRewardsDrawer }
                                    locale={ locale }
                                    points={ points }
                                    giftCodes={ giftCodes }
                                    marketplaceUrl={ marketplaceUrl }
                                    giftCodeUrl={ giftCodeUrl }
                                    menuItems={ marketplaceItems }
                                />
                            </Drawer>
                            <Button
                                type="text"
                                shape="round"
                                id="deckRewardsMobileBtn"
                                className="nkl-deck-rewards-btn"
                                aria-label={ getString( 'deck.label.rewardsMenu' ) }
                                aria-haspopup="true"
                                onClick={ this.toggleRewardsDrawer }
                                icon={
                                    !hasMarketplace && hasGiftCode ?
                                         <span className="anticon nkl-deck-icon">
                                             <Gift className="nkl-deck-icon reward-icon" />
                                         </span>
                                         :
                                         <span className="anticon nkl-deck-icon">
                                             <Store className="nkl-deck-icon reward-icon" />
                                         </span>
                                 }
                                aria-expanded={ deckRewardsVisible }>
                                    { !hasMarketplace && hasGiftCode && <span className="mobile-dot"></span> }
                                { points !== null && points >= 0 && hasMarketplace && <span className="points">{ points.toLocaleString( locale ) }</span> }
                            </Button>
                        </span>
                    }

                    { /* ARCADE MENU */ }
                    { arcadeUrl && !isDelegate &&
                        <span id="deck-arcadeMenuContainer">
                            <Popover
                                getPopupContainer={ () => document.getElementById( 'deck-arcadeMenuContainer' ) }
                                overlayClassName="nkl-deck-popover nkl-deck-popover-menu-container"
                                placement="bottomRight"
                                trigger="click"
                                onClick={ this.handlePopovers( 'deckArcade' ) }
                                open={ deckArcadeVisible }
                                content={ <ArcadeMenu tokenCount={ tokenCount } arcadeUrl={ arcadeUrl } closePopovers={ this.closePopovers } locale={ locale } /> }>
                                <Button
                                    type="text" shape="round"
                                    id="deckArcadePopoverBtn"
                                    className="nkl-deck-rewards-btn"
                                    aria-label={ getString( 'deck.label.arcadeMenu' ) }
                                    aria-haspopup="true"
                                    icon={
                                        <span className="anticon nkl-deck-icon">
                                            <Games className="nkl-deck-icon reward-icon" />
                                        </span>
                                    }
                                    aria-expanded={ deckArcadeVisible }>
                                    { <span className="desktop-count">{ tokenCount && tokenCount > 0 ? tokenCount.toLocaleString( locale ) : tokenCount && tokenCount > 99 ? '99+' : '0' }</span> }
                                    { tokenCount && tokenCount > 0 ? <span className="mobile-dot"></span> : null }
                                </Button>
                            </Popover>
                        </span>
                    }
                    { /* ARCADE MOBILE MENU */ }
                    { arcadeUrl && !isDelegate &&
                        <span id="deck-arcadeMobileContainer">
                            <Drawer
                                rootStyle={ { top: window.scrollY > 50 && !document.body.classList.contains( 'scroll-up' ) ? '50px' : '100px' } }
                                getContainer={ () => document.getElementById( 'deckSiteContent' ) }
                                className="nkl-deck-popover nkl-deck-popover-menu-container arcade-deck-drawer"
                                placement="left"
                                trigger="click"
                                onClose={ this.dismissArcadeDrawer }
                                width={ 320 }
                                closeIcon={ <Close /> }
                                onClick={ this.dismissArcadeDrawer }
                                title={
                                    <div className="rewards-header-mobile">
                                        <span className="anticon nkl-deck-icon"><Games className="reward-gift-icon deck-primary-color" /></span>
                                        <span className="gift-code-callout-header"><LocaleString code="deck.menu.arcade" /></span>
                                    </div>
                                }
                                open={ deckMobileArcadeVisible }>
                                <ArcadeMenu tokenCount={ tokenCount } arcadeUrl={ arcadeUrl } closePopovers={ this.dismissArcadeDrawer } locale={ locale } />
                            </Drawer>
                            <Button
                                type="text" shape="round"
                                id="deckArcadeMobileBtn"
                                className="nkl-deck-rewards-btn"
                                aria-label={ getString( 'deck.label.arcadeMenu' ) }
                                aria-haspopup="true"
                                icon={
                                    <span className="anticon nkl-deck-icon">
                                        <Games className="nkl-deck-icon reward-icon" />
                                    </span>
                                }
                                onClick={ this.toggleArcadeDrawer }
                                aria-expanded={ deckArcadeVisible }>
                                { <span className="desktop-count">{ tokenCount && tokenCount > 0 ? tokenCount.toLocaleString( locale ) : tokenCount && tokenCount > 99 ? '99+' : '0' }</span> }
                                { tokenCount && tokenCount > 0 ? <span className="mobile-dot"></span> : null }
                            </Button>
                        </span>
                    }
                    { /* NOTIFICATIONS LIST */ }
                    {
                        <span id="deck-notificationsMenuContainer">
                            <Popover
                                getPopupContainer={ () => document.getElementById( 'deck-notificationsMenuContainer' ) }
                                overlayClassName="nkl-deck-popover nkl-deck-popover-menu-container"
                                placement="bottomRight"
                                trigger="click"
                                onClick={ this.handlePopovers( 'deckNotifications' ) }
                                open={ deckNotificationsVisible }
                                content={
                                    <NotificationsPopover
                                        onChange={ this.handleNotificationChange }
                                        dataSource={ notifications }
                                        closePopovers={ this.closePopovers }
                                        locale={ locale }
                                        token={ this.props?.user?.access_token }
                                    />
                                }>
                                <Button
                                    type="text" shape="round"
                                    id="deckNotificationsPopoverBtn"
                                    className="nkl-deck-rewards-btn"
                                    aria-label={ getString( 'deck.label.notificationsMenu' ) }
                                    aria-haspopup="true"
                                    icon={
                                        <span className="anticon nkl-deck-icon">
                                            <Bell className="nkl-deck-icon notification-bell-icon" />
                                        </span>
                                    }
                                    aria-expanded={ deckNotificationsVisible }>

                                    {
                                        notifications.length > 0 &&
                                        <Badge type={ 'error' } count={
                                            unreadNotificationCount
                                        } />
                                    }
                                    {
                                        notifications.length > 0 &&
                                        <span className="mobile-dot"></span>
                                    }
                                </Button>
                            </Popover>
                        </span>
                    }
                    { /* MOBILE NOTIFICATIONS LIST */ }
                    {
                        <span id="deck-notificationsMobileContainer">
                            <Drawer
                                rootStyle={ { top: window.scrollY > 50 && !document.body.classList.contains( 'scroll-up' ) ? '50px' : '100px' } }
                                getContainer={ () => document.getElementById( 'deckSiteContent' ) }
                                className="nkl-deck-popover nkl-deck-popover-menu-container notifications-deck-drawer"
                                placement="left"
                                trigger="click"
                                onClose={ this.dismissNotificationsDrawer }
                                width={ 320 }
                                closeIcon={ <Close /> }
                                title={
                                    <div className="rewards-header-mobile deck-notifications-header">
                                        <span className="anticon nkl-deck-icon"><Bell className="reward-gift-icon deck-primary-color" /></span>
                                        <span className="gift-code-callout-header"><LocaleString code="deck.notifications.header" /></span>
                                    </div>
                                }
                                open={ deckMobileNotificationsVisible }>
                                <NotificationsPopover
                                    onChange={ this.handleNotificationChange }
                                    dataSource={ notifications }
                                    closePopovers={ this.dismissNotificationsDrawer }
                                    locale={ locale }
                                    token={ this.props?.user?.access_token }
                                />
                            </Drawer>
                            <Button
                                type="text" shape="round"
                                id="deckNotificationsPopoverBtn"
                                className="nkl-deck-rewards-btn"
                                aria-label={ getString( 'deck.label.notificationsMenu' ) }
                                aria-haspopup="true"
                                onClick={ this.toggleNotificationsDrawer }
                                icon={
                                    <span className="anticon nkl-deck-icon">
                                        <Bell className="nkl-deck-icon notification-bell-icon" />
                                    </span>
                                }
                                aria-expanded={ deckNotificationsVisible }>

                                {
                                    notifications.length > 0 &&
                                    <Badge type={ 'error' } count={
                                        unreadNotificationCount
                                    } />
                                }
                                {
                                    notifications.length > 0 &&
                                    <span className="mobile-dot"></span>
                                }
                            </Button>
                        </span>
                    }
                </div>

            </div>
        </Fragment>;
    }
}


const DeckAvatar = ( { avatarUrl, firstName } ) => {
    const firstInitial = firstName && firstName.charAt( 0 );

    return avatarUrl && avatarUrl !== null
        ? <Avatar size={ 'small' } src={ avatarUrl } alt={ getString( 'deck.label.userMenu' ) } />
        : <Avatar size={ 'small' } className='primary-background-avatar'>
            { firstInitial }
        </Avatar>;
};

const UserMenu = ( { isDelegate, auth, closePopovers, isUmbrella, user, userNavData, piersUser } ) => {
    const [ focusable, setFocusable ] = useState();
    const handleBlur = e => e.target === focusable[ focusable.length - 1 ] ? closePopovers() : false;
    const menuItems = [];
    useEffect( () => {
        setFocusable( tabbable( document.querySelector( '.deck-user-menu' ) ) );
    }, [] );
    const { access_token, session_id } = user;
    const clientSubdomain = piersUser?.solutions[ 0 ]?.solutionIdentity;
    const getUrl = url => url.replace( '${solution.identity}', clientSubdomain );
    const handleNavigate = async ( event, url ) => {
                url = getUrl( url );
                //if it's a full url, set the location - might be a link to something else or might not be umbrella
                const topicName = KAFKA_TOPICS.EXPERIENCE_NAVIGATION;
                const eventData = {
                    timestamp: Date.now(),
                    application: 'web-event-proxy',
                    sessionId: session_id,
                    companyId: user?.claims?.company_id,
                    sessionPersonId: user.claims.person_id,
                    navigationLocation: 'Deck',
                    action: 'CLICK',
                    currentPath: window.location.pathname,
                    targetPath: url,
                    domReference: JSON.stringify( event?.target.classList )
                };
                await SendEvent( access_token, eventData, topicName );
                closePopovers();
                if ( url.startsWith( 'https://' ) ) {
                    window.location.href = url;
                } else {
                    //otherwise do a routehistory push because it's an umbrella url
                    routeHistory.push( `${ url }/` );
                }
    };
    if ( userNavData && userNavData.items && userNavData.items.length > 0 && !isDelegate ) {
        userNavData.items.map( item => {
            if ( item.url.indexOf( 'door' ) === -1 && item.enabled )
            {
                let icon = [];
                if ( item.iconName ) {
                    // get the correct icon - hopefully the way they're named in nav service lines up with the naming from origami-icons
                    icon = icons.filter( icon => { return icon.name.toLowerCase() === item.iconName.replace( /\s/g, '' ).toLowerCase();} );
                }
                menuItems.push( { label: getString( item.labelKey ), key: item.id, icon: icon[ 0 ].component, className: 'menu-item deck-primary-color deck-primary-hover', onClick: () => handleNavigate( event, item.url ) } );
            }
        } );
    }
    if ( auth?.signOut ) {
        menuItems.push( { label: getString( 'deck.link.logout' ), key: 2, icon: <LogOut />, className: 'menu-item deck-primary-color deck-primary-hover', onClick: auth?.signOut, id: 'deckLogout' } );
    }
    return (
        <div className="profile-popover" onBlur={ handleBlur }>
            <div className="rewards-popover-section rewards-section">
                <div className="rewards-header">
                    <span className="gift-code-callout-header"><LocaleString code="deck.menu.salutation" replaceOptions={ { name: user?.claims?.given_name } } /></span>
                </div>
            </div>

            <Menu className="menu-item deck-primary-hover nkl-deck-popover-menu deck-user-menu" selectedKeys={ [] } items={ menuItems } style={ { width: 252, padding: 0 } } />
        </div>
    );
};


const ArcadeMenu = ( { arcadeUrl, closePopovers, tokenCount, locale } ) => {
    const [ focusable, setFocusable ] = useState();
    const handleBlur = e => e.target === focusable[ focusable.length - 1 ] ? closePopovers() : false;

    useEffect( () => {
        setFocusable( tabbable( document.querySelector( '.arcade-menu' ) ) );
    }, [] );

    return (
        <div className="arcade-popover">
            <div className="rewards-popover-section rewards-section">
                <div className="rewards-header">
                    <span className="anticon nkl-deck-icon"><Games className="reward-gift-icon deck-primary-color" /></span>
                    <span className="gift-code-callout-header"><LocaleString code="deck.menu.arcade" /></span>
                </div>
                <div className="balance"><LocaleString code="deck.menu.myBalance" /></div>
                <div className="nkl-points-display">
                    <span className="points-amount">{ tokenCount.toLocaleString( locale ) }</span><span className="points-label"><LocaleString code="deck.menu.gameplays" /></span>
                </div>
            </div>
            <div className="rewards-popover-section redeem-section">
                <ul className="arcade-menu">
                    { arcadeUrl &&
                        <li className="redeem-option" onBlur={ handleBlur } >
                            <a href={ arcadeUrl } className="market-link" target="_blank" rel="noreferrer">
                                <span className="link-label" onClick={ closePopovers }>
                                    <div className="rewards-store-description">
                                        <span className="link-text" >
                                            <LocaleString code="deck.menu.arcade" />
                                        </span>
                                    </div>
                                    <span className="deck-external-link-icon">
                                        <LinkExternal />
                                    </span>
                                </span>
                            </a>
                        </li>
                    }
                </ul>
            </div>
        </div>
    );
};
